module.exports = __webpack_public_path__ + "img/shape14.9fb55987.png";